import { ToggleButton, ToggleGroup } from 'components/Basic/ToggleGroup';
import { FacetPropsKeyValue } from 'components/Slider/styles';
import { ShadingWrap, ShadingLabel } from '../ManualToolModal/style';
import { DEFAULT_SHADING_VAL } from '../../constants';
import { convertShading } from '../../util';

type Props = {
	enableShadingEdit: boolean;
	canEditFacetProps: boolean;
	isGroundMount?: boolean;
	shading?: number;
	onChange: (value: number) => void;
};

export default function ShadingField({
	enableShadingEdit, canEditFacetProps, isGroundMount, shading, onChange,
}: Props) {
	if (!enableShadingEdit) return null;

	if (!canEditFacetProps) {
		return (
			<FacetPropsKeyValue>
				<label>Shading:</label>
				<span className="value 2">{convertShading(shading ? shading : DEFAULT_SHADING_VAL)}</span>
			</FacetPropsKeyValue>
		);
	}

	if (!isGroundMount) {
		return shading != null ? (
			<FacetPropsKeyValue>
				<label>Shading:</label>
				<span className="value 1">{shading.toFixed()}</span>
			</FacetPropsKeyValue>
		) : null;
	}

	return (
		<ShadingWrap className='facet-slope-wrap facet-slider-slope-info'>
			<ShadingLabel>
				<span>Shading:</span>
			</ShadingLabel>
			<ToggleGroup
				value={shading ? shading.toString() : DEFAULT_SHADING_VAL.toString()}
				onChange={(v) => onChange(+v)}
			>
				<ToggleButton value="14.08">None</ToggleButton>
				<ToggleButton value="15.85">low</ToggleButton>
				<ToggleButton value="20.28">medium</ToggleButton>
				<ToggleButton value="24.76">high</ToggleButton>
			</ToggleGroup>
		</ShadingWrap>
	);
}
